import { render } from "./PriceCampaignModal.vue?vue&type=template&id=5e599762"
import script from "./PriceCampaignModal.vue?vue&type=script&lang=js"
export * from "./PriceCampaignModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__